import { Create, Edit, SimpleForm, TextInput, SelectInput, DateField, ReferenceInput, ReferenceField } from 'react-admin';
import { Box } from '@mui/material';
import { CERTIFICATION_TYPES, CERTIFICATION_STATUS } from './constants';

export const CertificationCreate = () => (
  <Create>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <SelectInput source="certificationLevel" choices={CERTIFICATION_TYPES.map(c => ({ id: c, name: c }))} fullWidth />
        <DateField source="issueDate" label="Certified Date" />
        <DateField source="expiryDate" label="Expiry Date" />
        <TextInput source="issuingBody" fullWidth />
        <SelectInput source="status" choices={CERTIFICATION_STATUS.map(s => ({ id: s, name: s }))} fullWidth defaultValue="Active" />
      </Box>
    </SimpleForm>
  </Create>
);

export const CertificationEdit = () => (
  <Edit>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <ReferenceField source="employee.id" reference="employees" label="Employee">
          <TextInput source="name" />
        </ReferenceField>
        <SelectInput source="certificationLevel" choices={CERTIFICATION_TYPES.map(c => ({ id: c, name: c }))} fullWidth />
        <DateField source="issueDate" label="Certified Date" />
        <DateField source="expiryDate" label="Expiry Date" />
        <TextInput source="issuingBody" fullWidth />
        <SelectInput source="status" choices={CERTIFICATION_STATUS.map(s => ({ id: s, name: s }))} fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
);
